import layout from '@/layout'

export default {
  path: '/shareholders',
  component: layout,
  redirect: '/shareholders/num',
  name: 'shareholdersNum',
  meta: {
    title: 'shareholders',
    icon: 'shareholders'
  },
  children: [
    {
      path: '/shareholders/num',
      name: 'shareholdersNum',
      component: () => import('@/views/shareholders/shareholders-num'),
      meta: {
        title: 'shareholdersNum',
        icon: 'shareholders'
      }
    }
  ]
}
